import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const SimpleLoader = (props) => {
  const classes = useStyles();

  return (
    <Backdrop
      className={`${classes.backdrop} psh_SimpleLoader`}
      open={props.open}
      style={{...props?.style}}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default SimpleLoader;
